<template>
    <div class="mt-3">
        <div class="flex flex-col gap-3 md:grid md:grid-cols-3 md:items-center">
            <div class="hidden md:block"></div>
            <h1 class="text-3xl text-center">
                Tiendas en total
                <strong class="text-theme-primary">
                    {{ itemsNumber }}
                </strong>
            </h1>
            <div class="flex justify-center md:justify-end">
                <app-button
                    v-if="$ability.hasPermission('store:Create')"
                    color="success"
                    size="large"
                    @click="$router.push('/app/stores/new')"
                >
                    Nueva tienda
                </app-button>
            </div>
        </div>

        <div class="flex flex-wrap mt-2">
            <div class="w-full mt-3">
                <div class="flex justify-center mt-2">
                    <app-button relief @click="reloadItems">
                        Consultar 🔎
                    </app-button>
                </div>
            </div>

            <div
                class="flex flex-col lg:flex-row items-center justify-between w-full mt-3 gap-4"
            >
                <div
                    class="flex flex-wrap items-center justify-center lg:justify-start gap-2"
                >
                    <tooltip-button
                        v-show="
                            selected.length &&
                            $ability.hasPermission('store:Create')
                        "
                        icon="🗂️"
                        message="Clonar tienda"
                        @click="cloneSelected"
                    />
                </div>

                <div
                    class="flex flex-wrap items-center justify-center lg:justify-end gap-3"
                >
                    <list-settings-button
                        :value="{ pageSize }"
                        @change="onListSettingsChange"
                    />
                    <custom-pagination
                        v-model="currentPage"
                        :length="pagesNumber"
                        @input="listItems()"
                    />
                </div>
            </div>
        </div>

        <div class="w-full mt-2">
            <custom-table
                ref="selectableTable"
                :fields="$data.$fields"
                :items="itemsCurrent"
                :per-page="itemsCurrent.length"
                select-mode="single"
                selectable
                responsive
                outlined
                no-border-collapse
                hover
                class="w-full"
                items-empty-message="Nuestro sistema NO encuentra resultados. Intenta modificar los filtros de búsqueda."
                @flex-selected="onRowSelected"
            >
                <template #cell(id)="data">
                    <div class="flex items-center gap-2">
                        <router-link
                            :to="`/app/stores/detail/${data.item.id}`"
                            class="text-theme-primary"
                            title="Ver detalle"
                        >
                            <chevron-right-icon class="w-4 h-4" />
                        </router-link>
                        <span>
                            {{ data.item.enabledForDeliveries ? "🟢" : "⚪" }}
                        </span>
                        <uuid-display :value="data.item.id" />
                    </div>
                </template>
                <template #cell(name)="data">
                    <span class="text-center">
                        {{ data.item.name }}
                    </span>
                </template>
                <template #cell(phone)="data">
                    <span class="text-center">
                        {{ data.item.phone }}
                    </span>
                </template>
                <template #cell(address)="data">
                    <span class="text-center">
                        {{ data.item.address }}
                    </span>
                </template>

                <template #cell(createdAt)="data">
                    <span class="text-center">
                        {{ data.item.createdAt | date }}
                    </span>
                </template>

                <template #cell(updatedAt)="data">
                    <span class="text-center">
                        {{ data.item.updatedAt | date }}
                    </span>
                </template>
            </custom-table>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import ChevronRightIcon from "@/components/icons/ChevronRightIcon.vue";
import CustomTable from "@/components/utils/CustomTable.vue";
import TooltipButton from "@/components/utils/TooltipButton.vue";
import UuidDisplay from "@/components/utils/UuidDisplay.vue";

export default {
    name: "StoresIndex",
    components: { TooltipButton, CustomTable, ChevronRightIcon, UuidDisplay },
    layout: "app",
    meta: {},
    data: () => ({
        itemsCurrent: [],
        selected: [],
        $fields: [
            { key: "id", label: "ID", sortable: false },
            { key: "name", label: "Nombre", sortable: true },
            { key: "address", label: "Dirección" },
            { key: "phone", label: "Teléfono" },
            { key: "createdAt", label: "📆 Creación", sortable: true },
            { key: "updatedAt", label: "📆 Actualización", sortable: true }
        ],
        currentPage: 1,
        pagesNumber: 0,
        itemsNumber: 0,
        pageSize: 24
    }),
    computed: {
        ...mapGetters("control", ["backgroundColor"])
    },
    watch: {},
    async mounted() {
        const verifyPagePermission =
            this.$ability.verifyPagePermission.bind(this);
        if (!(await verifyPagePermission("store:List", "/app"))) return;
        this.listItems(true);
    },
    methods: {
        ...mapActions("stores", ["listStoresPaginated"]),
        async listItems(complete = false) {
            this.isLoading = true;
            this.$loading.show();
            try {
                const { items, pagination } = await this.listStoresPaginated({
                    complete,
                    itemsByPage: this.pageSize,
                    page: this.currentPage
                });
                this.itemsCurrent = items;
                if (pagination) {
                    this.itemsNumber = pagination.itemsNumber;
                    this.pagesNumber = pagination.pagesNumber;
                }
                this.$loading.hide();
            } catch (error) {
                this.$loading.hide();
                this.isLoading = false;
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
            }
        },
        async reloadItems() {
            this.currentPage = 1;
            await this.listItems(true);
        },
        onListSettingsChange({ pageSize }) {
            this.pageSize = pageSize;
            this.reloadItems();
        },
        onRowSelected(items) {
            this.selected = items;
        },
        clearSelected() {
            this.$refs.selectableTable.clearSelected();
            this.selected = [];
        },
        cloneSelected() {
            window
                .open(`/app/stores/clone/${this.selected[0].id}`, "_blank")
                .focus();
        }
    }
};
</script>
